import {
    VRCORE_GET_TEMPLATES,
    VRCORE_ADD_TEMPLATE,
    VRCORE_EDIT_TEMPLATE,
    VRCORE_REMOVE_TEMPLATE,
    GET_REPORT_TITLES
} from "./types";
import firebase from "firebase/app";

export const getTemplates = () => {
    return dispatch => {
        dispatch({ type: VRCORE_GET_TEMPLATES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: VRCORE_GET_TEMPLATES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/job_templates")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_TEMPLATES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: VRCORE_GET_TEMPLATES.FAIL });
        }
    };
};

export const getReportTitles = () => {
    return dispatch => {
        dispatch({
            type: GET_REPORT_TITLES.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT_TITLES.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("collections/report_titles")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT_TITLES.FAIL
            });
        }
    };
};
export const addTemplate = (template = false) => {
    return dispatch => {
        dispatch({ type: VRCORE_ADD_TEMPLATE.REQUEST });
        if (template)
            try {
                const templateJSON = {
                    profile: template
                };
                let count_id;
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({
                            type: VRCORE_ADD_TEMPLATE.FAIL
                        });
                    } else {
                        firebase
                            .database()
                            .ref(`/subjects/job_templates`)
                            .once("value")
                            .then(function(snapshot) {
                                count_id = snapshot.val();
                                if (typeof count_id !== "undefined" && count_id !== null)
                                    templateJSON.profile["template_id"] = (
                                        "000000" +
                                        (parseInt(
                                            Object.keys(count_id)[Object.keys(count_id).length - 1]
                                        ) +
                                            1)
                                    ).slice(-6);
                                else templateJSON.profile["template_id"] = "000001";
                                firebase.auth().onAuthStateChanged(user => {
                                    if (user === null) {
                                        dispatch({ type: VRCORE_ADD_TEMPLATE.FAIL });
                                    } else {
                                        firebase
                                            .database()
                                            .ref(
                                                `/subjects/job_templates/${
                                                    templateJSON.profile.template_id
                                                }/profile`
                                            )
                                            .set(templateJSON.profile);
                                        dispatch({
                                            type: VRCORE_ADD_TEMPLATE.SUCCESS
                                        });
                                    }
                                });
                            });
                    }
                });
            } catch (e) {
                dispatch({ type: VRCORE_ADD_TEMPLATE.FAIL });
            }
        else dispatch({ type: VRCORE_ADD_TEMPLATE.FAIL });
    };
};

export const editTemplate = (key = false, template = false) => {
    return dispatch => {
        dispatch({ type: VRCORE_EDIT_TEMPLATE.REQUEST });
        if (key && template)
            try {
                // const templateJSON = {
                //     profile: template
                // };
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({ type: VRCORE_EDIT_TEMPLATE.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref(`/subjects/job_templates/${template.template_id}/profile`)
                            .set(template);

                        dispatch({ type: VRCORE_EDIT_TEMPLATE.SUCCESS });
                    }
                });
            } catch (e) {
                dispatch({ type: VRCORE_EDIT_TEMPLATE.FAIL });
            }
        else dispatch({ type: VRCORE_EDIT_TEMPLATE.FAIL });
    };
};

export const removeTemplate = (key = false) => {
    return dispatch => {
        dispatch({ type: VRCORE_REMOVE_TEMPLATE.REQUEST });
        if (key)
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({ type: VRCORE_REMOVE_TEMPLATE.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref("/subjects/job_templates")
                            .child(key)
                            .remove();
                    }
                });
            } catch (e) {
                dispatch({ type: VRCORE_REMOVE_TEMPLATE.FAIL });
            }
        else dispatch({ type: VRCORE_REMOVE_TEMPLATE.FAIL });
    };
};
